import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@material-ui/core";
import React, { useState } from "react";
import { FormButton } from "../FormButton";

export interface ConfirmationDialogState {
    title?: string;
    showDialog: boolean;
    message: string;
    onOk?: () => void;
}

interface ConfirmationDialogProps {
    showDialog: boolean;
    title?: string;
    message?: string;
    cancelText?: string;
    okText?: string;
    onCancel?: Function;
    onOk?: Function;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    showDialog = false,
    title = "Confirmação",
    message,
    cancelText = "Cancelar",
    okText = "Ok",
    onCancel,
    onOk,
}) => {
    const [loading, setLoading] = useState(false);
    return (
        <Dialog open={showDialog} disableEscapeKeyDown disableBackdropClick>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        if (onCancel) {
                            onCancel();
                        }
                    }}
                >
                    {cancelText}
                </Button>
                <FormButton
                    loading={loading}
                    onClick={() => {
                        if (onOk) {
                            const result = onOk();
                            if (result instanceof Promise) {
                                setLoading(true);
                                result.finally(() => setLoading(false));
                            }
                        }
                    }}
                    color="primary"
                    autoFocus
                >
                    {okText}
                </FormButton>
            </DialogActions>
        </Dialog>
    );
};

export { ConfirmationDialog };
